import React from 'react';
import { translate } from 'react-i18next';
import classnames from 'classnames';

import { Form } from 'common/components';
import Validated from 'components/util/Validated';
import * as FormSections from 'subaccounts/components/form/sections';

import { createRoute } from 'lib/util';

const SubaccountsForm = ({
  accounts,
  company,
  depreciations,
  errors,
  handleAddCustomField,
  handleRemoveCustomField,
  handleSubmit,
  handleValueChange,
  isSaving,
  isSubmitted,
  handleGroupChange, //Groups
  handleCustomFieldChange, //Groups
  groups, //Groups
  subcompany,
  t,
  values,
}) => {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit();
      }}
    >
      <FormSections.General
        accounts={accounts}
        errors={errors}
        values={values}
        handleValueChange={handleValueChange}
        isSubmitted={isSubmitted}
      />

      {/* <FormSections.Depreciations
        depreciations={depreciations}
        errors={errors}
        values={values}
        handleValueChange={handleValueChange}
        isSubmitted={isSubmitted}
      />

      <FormSections.CustomFields
        depreciations={depreciations}
        errors={errors}
        values={values}
        handleAddCustomField={handleAddCustomField}
        handleRemoveCustomField={handleRemoveCustomField}
        handleValueChange={handleValueChange}
        isSubmitted={isSubmitted}
      /> */}

      {/* Groups */}
      <Form.CustomFields
        errors={errors}
        handleCustomFieldChange={handleCustomFieldChange}
        handleGroupChange={handleGroupChange}
        isSubmitted={isSubmitted}
        t={t}
        values={values}
        groups={groups}
      ></Form.CustomFields>
      {/* Groups */}

      <div className="col-md-12 mt-3">
        <Form.Button
          type={'submit'}
          text={t('actions.save')}
          isLoading={isSaving}
          disabled={isSaving}
          extraClassName={'pull-right btn-xs-block'}
        />

        <Form.Link
          to={createRoute(company.id, subcompany.id, `subaccounts`)}
          className={classnames('btn btn-secondary pull-right mr-3', {
            disabled: isSaving,
          })}
        >
          {t('actions.cancel')}
        </Form.Link>
        <div className="clearfix" />
      </div>
    </form>
  );
};

export default Validated({
  type: 'object',
  properties: {
    key: {
      type: 'string',
      minLength: 1,
    },
    name: {
      type: 'string',
      minLength: 1,
    },
    parent: {
      type: 'string',
      minLength: 1,
    },
    customFields: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            minLength: 1,
          },
          label: {
            type: 'string',
            minLength: 1,
          },
        },
        required: ['key', 'label'],
      },
    },
  },
  required: ['key', 'name', 'parent'],
})(translate()(SubaccountsForm));



// WEBPACK FOOTER //
// src/modules/secured/modules/subaccounts/components/form/SubaccountForm.js